export default __webpack_public_path__ + "static/media/aba-terminal.ab68214b.png";